(function () {
  function cartIcon() {
    return document.getElementById('cart-icon-bubble');
  }

  function announceAdded() {
    var live = document.getElementById('smk-cart-status');
    if (!live) {
      live = document.createElement('div');
      live.id = 'smk-cart-status';
      live.className = 'visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    live.textContent = 'Added to cart';
  }

  function paintCartIcon(sectionHtml) {
    var icon = cartIcon();
    if (!icon || !sectionHtml) return;
    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var inner = parsed.querySelector('.shopify-section');
    if (inner) icon.innerHTML = inner.innerHTML;
  }

  function pulseCart() {
    var icon = cartIcon();
    if (!icon) return;
    icon.classList.remove('smk-cart-pop');
    void icon.offsetWidth;
    icon.classList.add('smk-cart-pop');
  }

  function flyToCart(img) {
    var icon = cartIcon();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!icon || !img || reduce) {
      pulseCart();
      return;
    }
    var from = img.getBoundingClientRect();
    var to = icon.getBoundingClientRect();
    if (from.width < 2 || to.width < 2) {
      pulseCart();
      return;
    }
    var fly = img.cloneNode(true);
    fly.removeAttribute('srcset');
    fly.removeAttribute('sizes');
    if (img.currentSrc) fly.src = img.currentSrc;
    fly.className = 'smk-fly-pack';
    fly.alt = '';
    var width = Math.min(from.width, 140);
    var height = width * (from.height / from.width || 1);
    var left = from.left + (from.width - width) / 2;
    var top = from.top + (from.height - height) / 2;
    fly.style.left = left + 'px';
    fly.style.top = top + 'px';
    fly.style.width = width + 'px';
    fly.style.height = height + 'px';
    document.body.appendChild(fly);
    var dx = to.left + to.width / 2 - (left + width / 2);
    var dy = to.top + to.height / 2 - (top + height / 2);
    var scale = Math.max(0.12, Math.min(28 / width, 0.28));
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fly.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')';
        fly.style.opacity = '0.2';
      });
    });
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      if (fly.parentNode) fly.remove();
      pulseCart();
    }
    fly.addEventListener('transitionend', finish);
    setTimeout(finish, 900);
  }

  function land(img, sectionHtml) {
    paintCartIcon(sectionHtml);
    announceAdded();
    flyToCart(img);
  }

  window.SmokemonFlyCart = { land: land };

  function cardImage(root) {
    var card = root.closest('.product-card-wrapper') || root.closest('.card-wrapper');
    if (!card) return null;
    return card.querySelector('.card__media img, .card__inner .media img');
  }

  function clamp(input) {
    var min = 1;
    var max = input.max ? parseInt(input.max, 10) : null;
    var n = parseInt(input.value, 10);
    if (!isFinite(n) || n < min) n = min;
    if (max && isFinite(max) && n > max) n = max;
    input.value = String(n);
    var plus = input.parentElement && input.parentElement.querySelector('[data-smk-qty="1"]');
    if (plus) {
      var atMax = !!(max && isFinite(max) && n >= max);
      plus.classList.toggle('is-max', atMax);
      plus.disabled = atMax;
    }
  }

  function showError(root, message) {
    var err = root.querySelector('.smk-card-quick__error');
    if (!err) return;
    if (!message) {
      err.hidden = true;
      err.textContent = '';
      return;
    }
    err.hidden = false;
    err.textContent = message;
  }

  function add(root, btn) {
    var input = root.querySelector('.smk-card-quick__qty');
    var id = btn.getAttribute('data-variant-id');
    var qty = input ? parseInt(input.value, 10) || 1 : 1;
    var label = btn.querySelector('span');
    var pack = cardImage(root);
    if (!id || !window.routes || !window.routes.cart_add_url) return;

    btn.disabled = true;
    btn.classList.add('is-loading');
    if (label) label.textContent = 'Adding';
    showError(root, '');

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', String(qty));
    body.append('sections', 'cart-icon-bubble');
    body.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          showError(root, data.description || data.message || 'Could not add that.');
          return;
        }
        land(pack, data.sections && data.sections['cart-icon-bubble']);
        if (input) {
          input.value = '1';
          clamp(input);
        }
      })
      .catch(function () {
        showError(root, 'Could not add that. Try again.');
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        if (!btn.classList.contains('is-soldout')) btn.disabled = false;
        if (label && !btn.classList.contains('is-soldout')) label.textContent = 'Add to cart';
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-smk-qty], [data-smk-add]');
    if (!btn || btn.disabled) return;
    var root = btn.closest('.smk-card-quick');
    if (!root) return;
    event.preventDefault();
    event.stopPropagation();
    if (btn.hasAttribute('data-smk-qty')) {
      var input = root.querySelector('.smk-card-quick__qty');
      if (!input || input.disabled) return;
      var step = parseInt(btn.getAttribute('data-smk-qty'), 10) || 0;
      input.value = String((parseInt(input.value, 10) || 1) + step);
      clamp(input);
      return;
    }
    add(root, btn);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('smk-card-quick__qty')) return;
    clamp(event.target);
  });
})();
